import axios from "axios";


export const getSearchForm = (careersClientId, formType) => {
  const url = `${import.meta.env.VITE_ACTIVATE_BACKEND_API}/api/searchform/${encodeURIComponent(careersClientId)}/${encodeURIComponent(formType)}`;
  return axios.get(url).then((res) => res.data);
};

export const editSearchForm = (careersClientId, data) => {
  const url = `${import.meta.env.VITE_ACTIVATE_BACKEND_API}/api/searchform/editsearchform/${encodeURIComponent(careersClientId)}`;
  return axios.post(url, data).then((res) => res.data);
};

export const syncSearchFormFromProduction = (careersClientId, formType) => {
  const url = `${import.meta.env.VITE_ACTIVATE_BACKEND_API}/api/searchform/syncfromproduction/${encodeURIComponent(careersClientId)}/${encodeURIComponent(formType)}`;
  return axios.post(url).then((res) => res.data);
};
